import { Result } from '../util/Result';
import { User } from './models/User';
import { TransriptRequestFormState } from '../components/containers/RequestTranscriptContainer';
import { CourseGroupV2, CourseCategory } from './models/Course';
import { Notification } from './models/Notification';
import { Student } from './models/Student';
import { TranscriptRequest } from './models/TranscriptRequest';
import { BulkStudentUploadResult } from './models/BulkStudentUploadResult';
import { PagedTranscriptRequestResult } from './models/PagedTranscriptRequestResult';
import { TranscriptRequestResult } from './models/TranscriptRequestResult';

export const auth0Audience = process.env.AUTH0_AUDIENCE;
export enum Auth0Metadata {
  Roles = 'http://mnohs.org/roles',
  PersonId = 'http://mnohs.org/app_metadata/person_id',
}

/** An interface describing the backend API. */
export type API = {
  /** @deprecated */
  login(idToken: string): Promise<Result<User, undefined>>;
  /** @deprecated */
  editPronoun(pronoun: string): Promise<Result<User, undefined>>;
  /** @deprecated */
  editProfilePhoto(url: string): Promise<Result<User, undefined>>;
  /** @deprecated */
  requestTranscript(formState: TransriptRequestFormState): Promise<Result<undefined, undefined>>;

  // New endpoints
  /** GET /v1/Students */
  getStudents(token: string): Promise<Student[]>;
  /** GET /v1/Students/{personId} */
  getStudentById(personId: number, token: string): Promise<Student>;
  /** GET /v1/Students/search/{term} */
  filterStudents(term: string, token: string): Promise<Student[]>;
  /** PATCH /v1/Students/{personId} */
  updateStudent(personId: number, body: { pronoun: string; imageBase64: string }, token: string): Promise<Student>;
  /** POST /v1/Students - bulk upload students (csv upload) */
  bulkUploadStudents(csvFile: File, token: string): Promise<BulkStudentUploadResult>;
  /** POST /v1/data-import - bulk upload student results (multiple csv upload) */
  bulkUploadStudentResults(csvFiles: File[], token: string): Promise<void>;
  /** GET /v1/Students/{personId}/courses */
  getStudentCourses(personId: number, token: string): Promise<CourseCategory[]>;
  /** GET /v1/Students/{personId}/academic-check */
  getStudentCourseGroups(personId: number, token: string, abortController?: AbortController): Promise<CourseGroupV2[]>;
  /** POST /v1/Students/{personId}/transcript-request */
  studentRequestTranscript(personId: number, body: TranscriptRequest, token: string): Promise<void>;
  /** GET /v1/Students/{personId}/notifications */
  getStudentNotifications(personId: number, token: string): Promise<Notification[]>;
  /** GET /v1/Courses */
  getCourses(token: string): Promise<CourseCategory[]>;
  /** GET /v1/Courses/{courseId} */
  getCourseById(courseId: number, token: string): Promise<CourseCategory>;
  /** GET /v1/TranscriptRequests */
  getTranscriptRequests(token: string): Promise<TranscriptRequestResult[]>;
  /** GET /v1/TranscriptRequests/paged */
  getTranscriptRequestsByPage(page: number, pageSize: number, token: string): Promise<PagedTranscriptRequestResult>;
  /** GET /v1/Notifications */
  getNotifications(token: string): Promise<Notification[]>;
  /** GET /v1/Notifications/paged */
  getNotificationsByPage(page: number, pageSize: number, token: string): Promise<Notification[]>;
};
